import React from 'react';
import { map } from 'lodash';
import { AdSyncModel } from '@mm/state/model/AdModel';
import { MessengerAdRemoteAdModel } from '@mm/state/model/MessengerAdRemoteAdModel';
import ArrowIcon, { ARROW_TYPES } from '@mm/icons/general/ArrowIcon';
import Checkbox from '../../../../../common/components/Checkbox';
import { ErrorTooltip } from '../../../../../common/components/ErrorTooltip/ErrorTooltip';

type Props = {
  adSets: { [key: string]: AdSyncModel[] };
  showMoreExtended: boolean;
  onClickShowMore: () => void;
  restricted: boolean;
  id: number;
  needsShowMore: boolean;
  failingAds: { [key: string]: string };
  selectedAds: MessengerAdRemoteAdModel[];
  onClickAd: (id: string, checked: boolean) => void;
};

export const SelectedAds = (props: Props) => {
  const {
    adSets,
    failingAds,
    selectedAds,
    onClickAd,
    restricted,
    id,
    showMoreExtended,
    needsShowMore,
    onClickShowMore,
  } = props;
  if (restricted) {
    return (
      <div className="messenger-ad-detail__restricted-access-ads">
        {selectedAds.length === 0 && <span>No ads selected for sync</span>}
        {selectedAds.length > 0 && (
          <div className="messenger-ad-detail__ad-set">
            <div className="messenger-ad-detail__ad-set-name">
              Selected ads for sync
            </div>
            {map(selectedAds, (ad: MessengerAdRemoteAdModel, index: number) => {
              const failure = failingAds[ad.remoteId];
              return (
                <div className="ad-detail__ad-container" key={index}>
                  <Checkbox
                    className="ad-detail__ad-checkbox"
                    labelClassName="ad-detail__ad-checkbox-label"
                    isChecked={true}
                    disabled={true}
                    label={<div className="ad-detail__ad-label">{ad.name}</div>}
                  />
                  <ErrorTooltip
                    classPrefix="ad-detail"
                    validation={failure === undefined ? failure : [failure]}
                    hoverMode
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
  return (
    <div className="messenger-ad-detail__selected-ads">
      {map(adSets, (ads: AdSyncModel[], adSetId: string) => {
        return (
          <div className="messenger-ad-detail__ad-set" key={adSetId}>
            <div className="messenger-ad-detail__ad-set-name">
              {ads[0].adSetName}
            </div>
            {map(ads, (ad: AdSyncModel, index: number) => {
              const selectedAd = selectedAds.find(
                selected => selected.remoteId === ad.remoteId,
              );
              const failure = failingAds[ad.remoteId];
              return (
                <div className="ad-detail__ad-container" key={index}>
                  <Checkbox
                    className="ad-detail__ad-checkbox"
                    labelClassName="ad-detail__ad-checkbox-label"
                    isChecked={selectedAd !== undefined}
                    disabled={
                      selectedAd?.synced || (ad.synced && ad.syncedWith !== id)
                    }
                    tooltip={ad.synced ? 'Is already synced' : ''}
                    onToggle={e => onClickAd(ad.remoteId, e.target.checked)}
                    label={<div className="ad-detail__ad-label">{ad.name}</div>}
                  />
                  <ErrorTooltip
                    classPrefix="ad-detail"
                    validation={failure === undefined ? failure : [failure]}
                    hoverMode
                  />
                </div>
              );
            })}
          </div>
        );
      })}
      {needsShowMore && (
        <div
          className="messenger-ad-detail__show-more"
          onClick={onClickShowMore}
        >
          {showMoreExtended ? 'Show less ads' : 'Show more ads'}
          <ArrowIcon
            className="messenger-ad-detail__selected-ads-arrow"
            direction={showMoreExtended ? 'top' : 'bottom'}
            color="#3952fa"
            size={12}
            arrowType={ARROW_TYPES.CHEVRON}
          />
        </div>
      )}
    </div>
  );
};
